class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.resetOfferBar()
  }

  resetOfferBar(){
    if (document.querySelectorAll('.option_variant--plan .quantity__input')) {
      var SubscriptionInputs = document.querySelectorAll('.option_variant--plan .quantity__input')
      SubscriptionInputs.forEach((i)=>{
          i.dispatchEvent(new Event("change"));
      })
    }else{
      console.log('We are not in SCENT PACK product page')
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  async applyDiscountCode(code, makeRender=true, open = true) {
    try {
      const sectionIds = this.getSectionsToRender().map(section => section.id);
      const sectionUrl = window.location.pathname + '?sections=' + sectionIds.join(',');
  
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const productIdToCheck = 8600003805532
      const variantIdsToCheck = [47301261951324, 47301261984092, 47301262016860];
      const hasDesiredVariant = cart.items.some(item => variantIdsToCheck.includes(item.variant_id));
      const hasRequiredVariant = cart.items.some(item => item.product_id == productIdToCheck);
      if (!hasDesiredVariant || !hasRequiredVariant) {
       // console.log('Discount not applied');  
        // Clear discount
        const clearResponse = await fetch('/discount/clear');
        if (!clearResponse.ok) {
          throw new Error('Error clearing discount');
        }
  
        // Force cart update
        const cartUpdateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {},
          }),
        });
  
        const cartUpdateData = await cartUpdateResponse.json();
        const sections = await fetch(sectionUrl).then(res => res.json());
  
        const newResponse = {
          items: cartUpdateData.items,
          sections: sections
        };
       //console.log(newResponse)
        makeRender && this.renderContents(newResponse,);
      } else {
        // Apply discount code
        const discountResponse = await fetch(`/discount/${code}`);
        if (!discountResponse.ok) {
          throw new Error('Error applying discount code');
        }
  
        // Force cart update
        const cartUpdateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {},
          }),
        });
  
        const cartUpdateData = await cartUpdateResponse.json();
        const sections = await fetch(sectionUrl).then(res => res.json());
  
        const newResponse = {
          items: cartUpdateData.items,
          sections: sections
        };
       // console.log(newResponse)
        makeRender && this.renderContents(newResponse,);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
  
  
  

  renderContents(parsedState, open = true) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      open && this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
